export const SCRIPT_CONFIG = {
  // SEGMENT: {
  //   url: 'https://cdn.segment.com/analytics.js/v1/analytics.min.js',
  //   id: 'segment-analytics',
  //   methods: [
  //     'trackSubmit',
  //     'trackClick',
  //     'trackLink',
  //     'trackForm',
  //     'pageview',
  //     'identify',
  //     'reset',
  //     'group',
  //     'track',
  //     'ready',
  //     'alias',
  //     'debug',
  //     'page',
  //     'once',
  //     'off',
  //     'on',
  //     'addSourceMiddleware',
  //     'addIntegrationMiddleware',
  //     'setAnonymousId',
  //     'addDestinationMiddleware',
  //   ],
  //   version: '4.13.2',
  // },
  GOOGLE_MAPS: {
    id: 'google-maps',
  },
  STONLY: {
    url: 'https://stonly.com/js/widget/v2/stonly-widget.js',
    id: 'stonly-widget',
    widgetId: '4d748f19-7cc7-11ed-871a-0a52ff1ec764',
  },
  PYLON: {
    url: 'https://widget.usepylon.com/widget/3ae2d970-2dbb-43f2-b6c6-dab95aaee6df',
    id: 'pylon-widget',
  },
} as const;
